"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GuardianDto = /** @class */ (function () {
    function GuardianDto() {
    }
    return GuardianDto;
}());
exports.default = GuardianDto;
